@if (reloadBonuses.activeReloadBonuses().length) {
  <div>
    <div>
      @for (bonus of reloadBonuses.activeReloadBonuses(); track $index) {
        <div [ngClass]="{active: bonus?.active}" class="card flex items-center justify-end flex-row-reverse p-16 relative cursor-pointer" (click)="reloadBonuses.onChooseBonus(bonus?.bonusCode, true)">
          <div class="bonus-image px-10 sm:px-4">
            <img loading="lazy" class="" width="100" [src]="bonus?.image" alt="">
          </div>
          <div class="relative">
            <div class="uppercase text-16 font-weight-800 sm:text-12" [innerHTML]="bonus?.title | translate"></div>
            <div class="mt-10 text-20 font-weight-800 sm:text-16" [innerHTML]="bonus?.prize | translate"></div>
            <div class="secondary mt-10 text-14 font-weight-600" [innerHTML]="bonus?.condition | translate"></div>
          </div>
          <div [ngClass]="{active: bonus.active, 'no-active': !bonus.active}" class="bonus-circle"></div>
        </div>
      }
    </div>
  </div>
}
